<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app",
}
</script>
<style src="cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css"></style>



// WEBPACK FOOTER //
// src/App.vue